import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/HomeView.vue'),
    meta: { title: '武汉通测科技' }
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/Products.vue'),
    meta: { title: '武汉通测科技' }
  },
  {
    path: '/solutions',
    name: 'Solutions',
    component: () => import('../views/Solutions.vue'),
    meta: { title: '武汉通测科技' }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: { title: '武汉通测科技' }
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../views/News.vue'),
    meta: { title: '武汉通测科技' }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue'),
    meta: { title: '武汉通测科技' }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue'),
    meta: { title: '武汉通测科技' }
  },{
    path: '/management',
    name: 'Management',
    component: () => import('../views/Management/index.vue'),
    meta: { title: '武汉通测科技' }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

// 设置页面标题和路由拦截
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title || '公司官网'
  
  // 路由拦截逻辑：判断访问管理页时的权限
  if (to.path === '/management') {
    // 从sessionStorage获取token（长期存储）
    const token = sessionStorage.getItem('token')
    // 没有token则跳转到登录页
    if (!token) {
      return next('/login')
    }
  }
  
  // 正常放行其他路由
  next()
})

export default router